(() => {
  const mounted = new Map();
  function visible(element, boundary) {
    for (let node = element; node && node !== boundary; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    }
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }
  function mount() {
    for (const [panel, cleanup] of mounted) if (!panel.isConnected) { cleanup(); mounted.delete(panel); }
    document.querySelectorAll('[data-gobbi-review-panel]').forEach(panel => {
      if (mounted.has(panel)) return;
      const native = panel.querySelector('[data-gobbi-native-reviews]');
      const fallback = panel.querySelector('[data-gobbi-review-fallback]');
      if (!native || !fallback) return;
      const update = () => {
        const selector = Number(panel.dataset.reviewCount) === 0 ? '.jdgm-rev-widg__summary-text' : '.jdgm-rev__body, .jdgm-rev__title, .jdgm-rev__rating';
        fallback.hidden = [...native.querySelectorAll(selector)].some(review => (review.textContent.trim() || review.getAttribute('data-score')) && visible(review, panel));
      };
      const observer = new MutationObserver(update);
      observer.observe(native, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'], characterData: true});
      const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
      resize?.observe(native);
      mounted.set(panel, () => { observer.disconnect(); resize?.disconnect(); });
      update();
    });
  }
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => setTimeout(mount, 0));
  window.addEventListener('load', mount);
  mount();
})();
